import { Navigation } from './modules/navigation';
import { Gallery } from './modules/gallery';
import { FormValidation } from './modules/formValidation';
import { Accordion } from '../components/organisms/accordion/accordion';

window.addEventListener('load', () => {

    var navigationToggleElements = document.querySelectorAll('[data-module-navigation-toggle]');
    if (navigationToggleElements) {
        const navigation = new Navigation(navigationToggleElements);
        navigation.init();
    }

    var header = document.querySelector('.header');
    if (header) {
        setHeaderScrollClass(header);
        window.addEventListener('scroll', () => {
            setHeaderScrollClass(header);
        });
    }
    
    const galleryElements = document.querySelectorAll('[data-module-gallery]');
    if (galleryElements) {
        galleryElements.forEach((galleryElement: HTMLElement) => {
            const gallery = new Gallery(galleryElement);
            gallery.init();
        });
    }
    
    const formElements = document.querySelectorAll('[data-module-form-validation]');
    if (formElements) {
        const formValidation = new FormValidation(formElements);
        formValidation.init();
    }

    const accordionElements = document.querySelectorAll('[data-module-accordion]');
    if (accordionElements) {
        accordionElements.forEach((accordionElement: HTMLElement) => {
            const accordion = new Accordion(accordionElement);
            accordion.init();
        });
    }
});

function setHeaderScrollClass(header: Element) {
    var scroll = window.scrollY;
    if (scroll >= 1) {
        header.classList.add("header--scroll");
    } else {
        header.classList.remove("header--scroll");
    }
}